import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $SharingCurrentTraffic } from 'shared/atoms';
import { $CurrentPOIInfoAsAvailable } from '@poi/shared/current-poi-info';
import { SHARING_FB_PID, useDeepLink } from '~/utils/active';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const POIFacebook: FC = () => {
  const { canonicalUrl } = useAtomValue($SharingCurrentTraffic);
  const poi = useAtomValue($CurrentPOIInfoAsAvailable);

  const openUrl = useDeepLink({
    pid: SHARING_FB_PID,
    pageType: 'poi',
    poiId: poi.id,
  });

  return (
    <DynamicHead>
      <meta property="al:ios:url" content={openUrl} />
      <meta property="al:ios:app_store_id" content="1498607143" />
      <meta property="al:ios:app_name" content="Lemon8" />
      <meta property="al:android:url" content={openUrl} />
      <meta property="al:android:app_name" content="Lemon8" />
      <meta property="al:android:package" content="com.bd.nproject" />
      <meta property="al:web:url" content={canonicalUrl} />
    </DynamicHead>
  );
};
